import { Box } from '@chakra-ui/react';

const StyledInfoContainer = (props) => {
  return (
    <Box
      width='100%'
      display='flex'
      alignItems='center'
      justifyContent='space-between'
      {...props}
    />
  );
};

export default StyledInfoContainer;
